import { z } from "zod";

import { OfferDtoSchema } from "../../../dtos/offers";

export const ArchiveOfferRequestPathParamSchema = z.object({
  offerId: z.string().uuid(),
});

export type ArchiveOfferRequestPathParamType = z.infer<
  typeof ArchiveOfferRequestPathParamSchema
>;

export const ArchiveOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type ArchiveOfferResponseBodyType = z.infer<
  typeof ArchiveOfferResponseBodySchema
>;
